import React, { useEffect, createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { App } from './App';
const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false
  },
  styles: {
    global: {
      body: {
        bg: '#0a0a0a',
        color: 'white'
      }
    }
  },
  colors: {
    brand: {
      50: '#fef2f2',
      100: '#fee2e2',
      200: '#fecaca',
      300: '#fca5a5',
      400: '#f87171',
      500: '#dc2626',
      600: '#991b1b',
      700: '#7f1d1d',
      800: '#450a0a',
      900: '#1a0000'
    },
    fire: {
      50: '#fffbeb',
      100: '#fef3c7',
      200: '#fde68a',
      300: '#fcd34d',
      400: '#fbbf24',
      500: '#f59e0b',
      600: '#d97706',
      700: '#b45309',
      800: '#92400e',
      900: '#78350f'
    }
  },
  fonts: {
    heading: "'Playfair Display', serif",
    body: "'Inter', sans-serif"
  }
});
function Root() {
  useEffect(() => {
    // Set page title
    document.title = 'Maestros Ancestrales | Recupera Lo Que Es Tuyo';
    // Defer GTM loading by 3 seconds to prioritize page content
    const gtmTimeout = setTimeout(() => {
      ;
      (function (w: any, d: Document, s: string, l: string, i: string) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0] as HTMLElement;
        var j = d.createElement(s) as HTMLScriptElement;
        var dl = l !== 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        if (f && f.parentNode) {
          f.parentNode.insertBefore(j, f);
        } else {
          d.head.appendChild(j);
        }
      })(window, document, 'script', 'dataLayer', 'GTM-WK5ZP7PJ');
      // Google Tag Manager - Body noscript
      const noscript = document.createElement('noscript');
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-WK5ZP7PJ';
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';
      noscript.appendChild(iframe);
      document.body.insertBefore(noscript, document.body.firstChild);
    }, 3000);
    return () => clearTimeout(gtmTimeout);
  }, []);
  return <ChakraProvider theme={theme} data-id="element-53">
      <App data-id="element-54" />
    </ChakraProvider>;
}
render(<Root data-id="element-55" />, document.getElementById('root'));